export default __webpack_public_path__ + "static/media/mje_thumbnail.58e318f1.png";